import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { PaymentService } from '../payment/payment.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IndianCurrencyPipe } from "../../../pipe/indian-currency.pipe";
import { IPaymentList } from '../payment/ipayment';

@Component({
  selector: 'app-payment-list',
  imports: [
    MaterialModule,
    CommonModule,
    TranslateModule,
    TablerIconsModule,
    IndianCurrencyPipe
  ],
  templateUrl: './payment-list.component.html',
  styleUrl: './payment-list.component.scss'
})
export class PaymentListComponent implements OnInit {

  dataSource = new MatTableDataSource<IPaymentList>();
  displayedColumns: string[] = ['paymentDate', 'amount'];
  patientName: string;
  billno: string;

  constructor(
    private _paymentService: PaymentService,
    @Inject(MAT_DIALOG_DATA) private _data: { billId?: number, patientName: string, billno: string },
  ) {
    this.billno = this._data?.billno
  }

  ngOnInit(): void {
    if (this._data.billId) {
      this._paymentService.getPatientPaymentHistory(this._data.billId).subscribe((response) => {
        this.dataSource.data = Array.isArray(response.result) ? response.result : [response.result];
      })
    }

    this.patientName = this._data.patientName;

  }

}
